"use strict";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthorizationCodeTokenClient = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = require("@ori/axios");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("./constants");
var _OidcTokenStorage = require("./storage/OidcTokenStorage");
var _OidcIdToken = require("./tokens/OidcIdToken");
var _OidcToken = require("./tokens/OidcToken");
var _singleton = require("./utils/singleton");
var _class, _AuthorizationCodeTokenClient;
var AuthorizationCodeTokenClient = exports.AuthorizationCodeTokenClient = (0, _singleton.singleton)(_class = (_AuthorizationCodeTokenClient = /*#__PURE__*/ function() {
    function AuthorizationCodeTokenClient(options) {
        _class_call_check(this, AuthorizationCodeTokenClient);
        (0, _defineProperty2.default)(this, "options", void 0);
        (0, _defineProperty2.default)(this, "storage", void 0);
        this.options = options;
        var _this_options_storage;
        this.storage = (_this_options_storage = this.options.storage) !== null && _this_options_storage !== void 0 ? _this_options_storage : new _OidcTokenStorage.OidcTokenStorage();
    }
    _create_class(AuthorizationCodeTokenClient, [
        {
            key: "initializeTokenFromAuthorizationCode",
            value: function initializeTokenFromAuthorizationCode() {
                var _this = this;
                return _async_to_generator(function() {
                    var authCode, authCodeTokenData, accessToken, _accessToken_getClaim, _ref, user, idToken;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                authCode = _this.storage.authorizationCode.get();
                                if (!authCode) {
                                    throw new Error("Auth - missing authorization code");
                                }
                                return [
                                    4,
                                    _this.requestToken(authCode)
                                ];
                            case 1:
                                authCodeTokenData = _state.sent();
                                accessToken = new _OidcToken.OidcToken(authCodeTokenData.access_token);
                                user = (_ref = (_accessToken_getClaim = accessToken.getClaim('consultant_number')) !== null && _accessToken_getClaim !== void 0 ? _accessToken_getClaim : accessToken.getClaim('preferred_username')) !== null && _ref !== void 0 ? _ref : _constants.UNKNOWN_USER;
                                _this.storage.setAccessToken({
                                    // Create expiration date manually,
                                    // because we wont get exact time that token expires,
                                    // but just only expires_in
                                    ExpirationDate: new Date(Date.now() + authCodeTokenData.expires_in * 1000).toString(),
                                    Token: authCodeTokenData.access_token,
                                    User: user
                                });
                                // Simulate the same behavior as Online login.
                                _jsCookie.default.set(_constants.LOGGED_IN_USER_COOKIE, user);
                                idToken = new _OidcIdToken.OidcIdToken(authCodeTokenData.id_token);
                                _this.storage.setIdToken(idToken);
                                _this.storage.authorizationCode.remove();
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestToken",
            value: function requestToken(authCode) {
                var _this = this;
                return _async_to_generator(function() {
                    var redirectUri, codeVerifier, tokenRequest, response, result, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                redirectUri = _this.storage.redirectUri.get();
                                if (!redirectUri) {
                                    throw new Error("Redirect URI is missing");
                                }
                                codeVerifier = _this.storage.codeVerifier.get();
                                if (!codeVerifier) {
                                    throw new Error("Code verifier is missing");
                                }
                                tokenRequest = fetch(new _axios.SafeURL('/connect/token', _this.options.identityUrl || window.location.origin), _object_spread_props(_object_spread({}, AuthorizationCodeTokenClient.REQUEST_OPTIONS), {
                                    body: new URLSearchParams({
                                        // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
                                        client_id: _this.options.clientId,
                                        // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
                                        grant_type: 'authorization_code',
                                        code: authCode,
                                        // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
                                        redirect_uri: redirectUri,
                                        // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
                                        code_verifier: codeVerifier
                                    })
                                }));
                                return [
                                    4,
                                    tokenRequest
                                ];
                            case 1:
                                response = _state.sent();
                                if (!response.ok) {
                                    throw new Error("".concat(response.status, " ").concat(response.statusText));
                                }
                                result = response.json();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                error = _state.sent();
                                throw new Error("Token request has failed: ".concat(error));
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthorizationCodeTokenClient;
}(), (0, _defineProperty2.default)(_AuthorizationCodeTokenClient, "REQUEST_OPTIONS", {
    credentials: 'same-origin',
    headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
        'X-Fetch-Api': '1',
        // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
        'X-Requested-With': 'XMLHttpRequest',
        // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
}), _AuthorizationCodeTokenClient)) || _class; //# sourceMappingURL=AuthorizationCodeTokenClient.js.map
